"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _string = _interopRequireDefault(require("./string"));
var _default = exports["default"] = {
  /**
   * Format the duration between 2 dates
   * using momentjs. See momentjs docs for more information
   * https://momentjs.com/docs/#/displaying/difference/
   * @param {String} startDate
   * @param {String} endDate
   * @param {('days' | 'months' | 'years')} unit
   * @returns string - The formatted duration
   */
  duration: function duration(startDate, endDate, unit) {
    if (endDate === void 0) {
      endDate = new Date();
    }
    if (unit === void 0) {
      unit = 'days';
    }
    var end = (0, _moment["default"])(endDate);
    var start = (0, _moment["default"])(startDate);
    var duration = end.diff(start, unit);
    var label = unit === 'days' ? _string["default"].pluralize(duration, 'day', 'days') : unit === 'months' ? _string["default"].pluralize(duration, 'month', 'months') : unit === 'years' ? _string["default"].pluralize(duration, 'year', 'years') : unit;
    return duration + " " + label;
  }
};